import React from 'react';

// Hand-built sticker marks for brand-defining spots (hero badge, section
// icons) instead of stock icon-library glyphs. Kept to a handful, on
// purpose, so they stay unique rather than becoming another icon set.
const base = {
  viewBox: '0 0 48 48',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 3,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const StickerBolt = (props) => (
  <svg {...base} className={props.className}>
    <path d="M26 4 L11 27h9l-3 17 18-25h-10z" strokeLinejoin="round" />
  </svg>
);

export const StickerBriefcase = (props) => (
  <svg {...base} className={props.className}>
    <path d="M18 12v-3a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v3" />
    <rect x="6" y="12" width="36" height="26" rx="4" />
    <path d="M6 24h36" />
    <path d="M20 24v3h8v-3" />
  </svg>
);

export const StickerGradCap = (props) => (
  <svg {...base} className={props.className}>
    <path d="M24 8 4 18l20 9 20-9-20-9Z" strokeLinejoin="round" />
    <path d="M13 22.5V33c0 2.5 5 5 11 5s11-2.5 11-5V22.5" />
    <path d="M42 18v11" />
    <circle cx="42" cy="32" r="1.8" fill="currentColor" />
  </svg>
);

export const StickerCode = (props) => (
  <svg {...base} className={props.className}>
    <path d="M17 14 6 24l11 10" />
    <path d="M31 14l11 10-11 10" />
    <path d="M27 10 21 38" />
  </svg>
);

export const StickerDevices = (props) => (
  <svg {...base} className={props.className}>
    <rect x="4" y="8" width="26" height="19" rx="2" />
    <path d="M4 33h26" />
    <rect x="32" y="16" width="12" height="22" rx="2.5" />
    <path d="M36 33.5h4" />
  </svg>
);

export const StickerCloud = (props) => (
  <svg {...base} className={props.className}>
    <path d="M14 33a9 9 0 1 1 2-17.8A11 11 0 0 1 37 20a7 7 0 0 1-1 13H14Z" strokeLinejoin="round" />
    <path d="M15 40v2M23 40v3M31 40v2" />
  </svg>
);

export const StickerPlug = (props) => (
  <svg {...base} className={props.className}>
    <path d="M18 4v10M30 4v10" />
    <path d="M12 14h24v9a12 12 0 0 1-24 0v-9Z" strokeLinejoin="round" />
    <path d="M24 35v6" />
    <path d="M17 44h14" />
  </svg>
);

export const StickerDoc = (props) => (
  <svg {...base} className={props.className}>
    <path d="M12 4h16l8 8v28a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" strokeLinejoin="round" />
    <path d="M28 4v8h8" />
    <path d="M15 24h18M15 30h18M15 36h11" />
  </svg>
);

export const StickerWrench = (props) => (
  <svg {...base} className={props.className}>
    <path d="M31 8a10 10 0 0 0-13.6 11L6 30.4 9.6 34l11.4-11.4A10 10 0 0 0 40 9l-6.5 6.5-5-5L31 8Z" strokeLinejoin="round" />
  </svg>
);
